'use strict';

// capture JS errors
module.exports = function (errManager) {
    var captureCfg = errManager.cfgManager.get('autoCatch');
    if (captureCfg.js) {
        // global JS error
        var origin = window.onerror;
        window.onerror = function () {
            errManager.parseWindowError.apply(errManager, arguments);
            origin && origin.apply(window, arguments);
        };

        // unhandled promise rejection
        var ADD_EVENT = window.addEventListener || window.attachEvent;
        ADD_EVENT('unhandledrejection', function () {
            errManager.parsePromiseUnhandled.apply(errManager, arguments);
        });
    }

    // console.error
    if (captureCfg.console && window.console && window.console.error) {
        var consoleError = window.console.error;
        window.console.error = function () {
            errManager.parseConsoleError.apply(errManager, arguments);
            consoleError && consoleError.apply(window.console, arguments);
        };
    }
};